import WebinarLanding from './WebinarLanding';

function App() {
  return (
    <div className="App">
      <WebinarLanding />
    </div>
  );
}

export default App;
